import { Link } from 'react-router-dom';
import { mangaList, categories } from '@/mocks/manga';
import MangaCard from '@/components/feature/MangaCard';

export default function AllMangaSection() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">全部漫画</h2>
          <p className="text-foreground-500 text-sm mt-2">探索所有腐漫作品，发现你的最爱</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4 mb-8">
          {mangaList.map((manga) => (
            <MangaCard key={manga.id} manga={manga} />
          ))}
        </div>

        <div className="text-center">
          <div className="inline-flex flex-wrap items-center justify-center gap-2">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-5 py-2 border border-background-300/60 rounded-full text-sm text-foreground-600 hover:text-accent-600 hover:border-accent-300 hover:bg-accent-50/50 transition-all duration-300 whitespace-nowrap"
              >
                {cat.label} 专区
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}